import { cn } from '../../lib/utils';
import logoImg from '../../assets/brand/logo.png';

export const Logo = ({
    className,
    imgClassName,
    size = "md"
}) => {
    const sizes = {
        sm: "h-8 w-auto",
        md: "h-14 w-auto",
        lg: "h-16 w-auto"
    };

    const currentSizeClass = sizes[size] || sizes.md;

    return (
        <div className={cn("flex items-center", className)}>
            <img
                src={logoImg}
                alt="FinMatrixRQ Logo"
                className={cn(currentSizeClass, "object-contain dark:brightness-0 dark:invert", imgClassName)}
            />
        </div>
    );
};

export default Logo;
